import React from 'react'
import { Cancel as CancelIcon } from '@mui/icons-material'
import { ConfirmDialog } from '@edge/spark/ui'
import { formatWordsFromCamelCase } from '@edge/spark/utils'
import type { CardConfigModalProps } from './types'

export const CancelConfirmDialog: React.VFC<CardConfigModalProps> = ({
    type,
    open,
    onSuccess,
    onFailure,
    cardTitle,
}: CardConfigModalProps) => (
    <ConfirmDialog
        open={open}
        onSuccess={onSuccess}
        onFailure={onFailure}
        title="Cancel"
        successButtonText="Yes"
        failureButtonText="No"
        icon={<CancelIcon />}
        message="Are you sure you want to cancel?"
        postMessageEm={cardTitle || formatWordsFromCamelCase(type)}
    />
)

export default CancelConfirmDialog
